import axios from "axios";
import { normalizeCharacters } from "../utils";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const API_BASE_SRC_CUENTA = API_BASE_SRC + "/aperturaCA/wp";
const API_BASE_SRC_MERLIN = API_BASE_SRC + "/ventaTC/wp";
const ofertaCamp = process.env.VUE_APP_CAMP || "ofertaDigital";

const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} payload payload para el endpoint
   */
  request({ endPoint, payload }) {
    // Siempre retornar la promesa de axios
    const body = payload ? JSON.parse(JSON.stringify(payload)) : payload;
    return axios.post(`${API_BASE_SRC}/${endPoint}`, body);
  },
  consulta(payload) {
    const body = JSON.parse(JSON.stringify(payload));
    body.captchaResponse = body.captcha;
    delete body.captcha;
    body.nroDoc = body.numeroDoc;
    delete body.numeroDoc;
    body.c = `${ofertaCamp}`;
    body.fingerprint = "9999991212";
    body.referrer = window.document.referrer;
    body.originUrl = window.location.href;
    return axios.post(`${API_BASE_SRC_CUENTA}/tieneCuenta`, body);
  },
  merlin(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    // El domicilio no puede tener caracteres "especiales"
    body.domicilio.calle = normalizeCharacters(body.domicilio.calle);
    body.domicilio.localidad = normalizeCharacters(body.domicilio.localidad);
    return axios.post(
      `${API_BASE_SRC_MERLIN}/merlinCloud/normalizarDomicilio`,
      body
    );
  },
  normalizarCelular(payload) {
    let body = {
      level1: "AR",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      phoneNumber: payload,
      characteristic: "",
      postalCode: "",
      prefix: "",
      additionalData: ""
    };
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/normalizarTelefono`, body);
  },
  recotizacionCobertura(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(
      `${API_BASE_SRC}/segurosHogar/obtenerRecotizacionCoberturas`,
      body
    );
  },
  downloadPdf(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(
      `${API_BASE_SRC}/segurosHogar/obtenerPdfSegurosHogar`,
      body
    );
  },
  tokenizarUser(payload) {
    return axios.post(`${API_BASE_SRC}/customer/tokenize`, payload);
  }
};

export default om;
